import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  EMPLOYEES_APP__GO_TO_APP_STORE,
  EMPLOYEES_APP__GO_TO_WEB_ONBOARDING,
  EMPLOYEES_APP__SELLING_POINT,
  EMPLOYEES_APP__TITLE,
} from 'translations/constants';
import { getUserPlatform } from './helpers';
import { IPBackground, IPButton, IPContainer, IPLinkToOnboarding, IPSalesPitch, IPTitle } from './styles';

interface LocationState {
  from?: string;
}

const EmployeeApp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const state = location.state as LocationState | undefined;
  const from = state?.from || '/';

  const handleOnboardClick = () => {
    const platform = getUserPlatform();
    if (platform === 'Android') {
      window.open('https://play.google.com/store/apps/details?id=com.updatepro.mobile', '_blank');
    } else if (platform === 'iOS') {
      window.open('https://apps.apple.com/ro/app/uportal/id6739351774', '_blank');
    }
  };

  return (
    <IPBackground>
      <IPContainer>
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" p="25px">
          <IPTitle>{t(EMPLOYEES_APP__TITLE)}</IPTitle>
          <IPSalesPitch variant="body1">{t(EMPLOYEES_APP__SELLING_POINT)}</IPSalesPitch>
          <IPButton text={t(EMPLOYEES_APP__GO_TO_APP_STORE)} onClick={handleOnboardClick} />
          <IPLinkToOnboarding onClick={() => navigate(`${from}?skipMobile=true`)} sx={{ marginTop: '16px' }}>
            {t(EMPLOYEES_APP__GO_TO_WEB_ONBOARDING)}
          </IPLinkToOnboarding>
        </Box>
      </IPContainer>
    </IPBackground>
  );
};

export default EmployeeApp;
